/**
 * Organization provider helpers — Reconflux
 *
 * Pure selection logic kept out of OrganizationProvider.tsx so it stays
 * unit-testable without rendering the provider (issue #372: the bug was
 * these lookups running against a stale, pre-refresh org list).
 */

import type { Organization, OrgRole } from '../types/database'

export interface OrganizationWithRole extends Organization {
  role: OrgRole
}

/** Exact match only — callers must pass the list, not rely on a memoized one. */
export function findOrganizationById(
  orgs: OrganizationWithRole[],
  orgId: string
): OrganizationWithRole | null {
  return orgs.find(o => o.id === orgId) ?? null
}

/**
 * Restore-or-default selection used after fetching the org list: prefers
 * `preferredId` (e.g. the id saved in localStorage) but falls back to the
 * first org so a deleted/stale id doesn't leave the user without a context.
 */
export function pickCurrentOrganization(
  orgs: OrganizationWithRole[],
  preferredId: string | null
): OrganizationWithRole | null {
  if (orgs.length === 0) return null
  return orgs.find(o => o.id === preferredId) ?? orgs[0]
}
